import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { Footer } from '../components/footer.js';
import { logos } from '../utils/logos.js';
import { styles } from '../assets/styles';
import { Href1, Href2, Href3 } from '../components/hrefs.js';
import '../assets/animations.css';

export default function Classic() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 777);

    return () => clearTimeout(timer);
  }, []);

  return (
    /* BOX CONTAINER */
    <Box sx={styles.container}>
      {/* BOX LOGO 1 */}
      <Box sx={styles.logo1}>
        <a href="/">
          <img className="logoPoke" src={logos.logo1} style={styles.width100} />
        </a>
      </Box>
      <Box sx={styles.logo2}>
        <img className="logoPoke" src={logos.mainLogo} style={styles.width100} />
      </Box>
      <Href1 />
      <Href2 />
      <Href3 />
      <Footer />
    </Box>
  );
}
